import { create } from "zustand";
import { devtools, persist } from "zustand/middleware";
//右侧购物车抽屉打开状态
interface State {
  open:boolean;
  setOpen: (open: boolean) => void;
}

export const useCartDrawerOpenStore = create(
  devtools(
    persist<State>(
      (set) => ({
        open:false,
        setOpen:(open: boolean) => set((state) => ({ open: open })),
      }),
      {
        name: "open-storage",
      }
    ),
    {
      name: "openStore",
    }
  )
);